import * as React from 'react';
import { Body1, Responsive } from '@cian/ui-kit';

import { IRoomStatsCell } from '../../../../../../types/newbuildingsCompare';
import { RoomStatsCellDesktop } from './RoomStatsCellDesktop';
import { RoomStatsCellMobile } from './RoomStatsCellMobile';
import * as style from './style.css';

export interface IRoomStatsCellProps {
  cell: IRoomStatsCell;
  withoutBottomPadding?: boolean;
}

export const RoomStatsCell = ({ cell, withoutBottomPadding }: IRoomStatsCellProps): React.JSX.Element => {
  const { data } = cell;

  if (!data) {
    return (
      <div className={style['container']}>
        <Body1 color="text-secondary-default">{cell.state.text}</Body1>
      </div>
    );
  }

  return (
    <>
      <Responsive phone tablet>
        <RoomStatsCellMobile data={data} withoutBottomPadding={withoutBottomPadding} />
      </Responsive>
      <Responsive desktop>
        <RoomStatsCellDesktop data={data} />
      </Responsive>
    </>
  );
};
